module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banet-datetime-picker"
  }, [_c('VueBulmaDatepicker', {
    attrs: {
      "config": _vm.config,
      "placeholder": _vm.placeholder,
      "clearTooltip": _vm.getTranslation('lbl_clear')
    },
    on: {
      "datesSelected": _vm.datesSelected
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f042412!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/protected/components/banet-datetime-picker/DateTimePicker.vue
// module id = 693
// module chunks = 0